// store/ourServiceStore.ts
import { create } from "zustand";

type LangContent = {
  en: string;
  id: string;
};

export type OurService = {
  title: LangContent;
  sub_title: LangContent;
  slug: string;
  image_desktop: string;
  image_mobile: string;
  imagePosition: "left" | "right";
  content: LangContent;
};

type OurServiceStore = {
  ourservices: OurService[];
  fetchOurServices: (lang: "en" | "id") => Promise<void>;
};

const baseUrl = "https://admin.talentlinkindo.com/api";

export const useOurServiceStore = create<OurServiceStore>((set) => ({
  ourservices: [],

  fetchOurServices: async (lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/our-service/content`);
      if (!res.ok) throw new Error("Failed to fetch our service");

      const json = await res.json();
      set({ ourservices: json.data || [] });
    } catch (error) {
      console.error("Failed to fetch our service:", error);
    }
  },
}));